import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from "../../utils/RecordsPagination";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tooltip from "@material-ui/core/Tooltip";

// material icons
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import Approve from "@material-ui/icons/Done";
import Decline from "@material-ui/icons/Close";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Grid,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import { appConstants } from "../../_constants";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  input: {
    marginTop: "0 !important",
  },
  nb: {
    color: "red",
    fontSize: "12px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: {
    marginTop: "0px",
    width: "100%",
  },
  icon: {
    margin: "8px 0px 8px 0px",
    position: "relative",
    top: "7px",
    paddingLeft: "8px",
  },
});

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: appConstants.REGIONAL_COLOR,
    fontSize: "14px",
    fontWeight: "lighter",
  },
  body: {
    fontSize: 14,
  },
  root: {
    padding: "5px 35px 4px 29px",
  },
}))(TableCell);

function DataEntryTableStructure(props) {
  const {
    classes,
    filterAirlines,
    user,
    approveDataEntry,
    declineDataEntry,
    error,
    formError,
    selectChange,
    isCommentModalOpen,
    openCommentModal,
    closeCommentModal,
    comment,
    processName,
    dataEntryData,
    openViewMore,
  } = props;

  return (
    <div>
      {/* Comments Modal */}
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={isCommentModalOpen}
        onClose={closeCommentModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          style={{ backgroundColor: appConstants.REGIONAL_COLOR }}
        >
          <span style={{ color: "white", textTransform: "uppercase" }}>
            Add Comment
          </span>
        </DialogTitle>
        <DialogContent style={{ marginTop: "20px" }}>
          <Grid container spacing={24}>
            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Comments"
                id="comment"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  name: "comment",
                  type: "text",
                  value: comment,
                  onChange: selectChange,
                }}
              />
              {error && <span style={{ color: "red" }}>{formError}</span>}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCommentModal} color="danger">
            Cancel
          </Button>
          <Button
            onClick={() =>
              processName === "Approve"
                ? approveDataEntry()
                : declineDataEntry()
            }
            color="success"
            autoFocus
          >
            {processName}
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
              <CustomTableCell>
                Airline <br /> Name
              </CustomTableCell>
              <CustomTableCell>Flight Number</CustomTableCell>
              <CustomTableCell>
                Departure <br /> Date{" "}
              </CustomTableCell>
              <CustomTableCell>
                Departure <br /> Location{" "}
              </CustomTableCell>
              <CustomTableCell>
                Destination <br /> Location
              </CustomTableCell>
              <CustomTableCell>Is Regional</CustomTableCell>
              <CustomTableCell>Status</CustomTableCell>
              <CustomTableCell>Actions</CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataEntryData.map((item, key) => {
              return (
                <TableRow hover key={item.Id}>
                  <TableCell>{filterAirlines(item.AirlineId)}</TableCell>
                  <TableCell>{item.FlightNo}</TableCell>
                  <TableCell>
                    {item.DepartureDate
                      ? appHelpers.formatDate(
                          item.DepartureDate,
                          "MMM DD, YYYY"
                        )
                      : ""}
                  </TableCell>
                  <TableCell>{item.DepartureLocation}</TableCell>
                  <TableCell>{item.DestinationLocation}</TableCell>
                  <TableCell>{item.IsRegional ? "Yes" : "No"}</TableCell>
                   <TableCell>
                    {item.Status === 0 && (
                      <span
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#828282",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          color: "#ffffff",
                        }}
                      >
                        Pending
                      </span>
                    )}
                    {item.Status === 1 && (
                      <span
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#43a047",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          color: "#ffffff",
                        }}
                      >
                        Approved
                      </span>
                    )}
                    {item.Status === 2 && (
                      <span
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#dd2735",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          color: "#ffffff",
                        }}
                      >
                        Declined
                      </span>
                    )}
                  </TableCell>
                  <TableCell>
                    {item.CreatedBy === user && item.Status === 0 ? (
                      <span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => openViewMore(item)}
                        >
                          <Tooltip title="View" placement="top">
                            <span className={classes.icon}>
                              <ViewIcon />
                            </span>
                          </Tooltip>
                        </span>
                      </span>
                    ) : (
                      item.Status === 0 && (
                        <span>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => openViewMore(item)}
                          >
                            <Tooltip title="View" placement="top">
                              <span className={classes.icon}>
                                <ViewIcon />
                              </span>
                            </Tooltip>
                          </span>
                          <span
                            onClick={() => openCommentModal(item.Id, "Approve")}
                            style={{
                              cursor: "pointer",
                              color: "#43a047",
                              padding: "0 5px",
                            }}
                          >
                            <Tooltip title="Approve" placement="top">
                              <span className={classes.icon}>
                                <Approve />
                              </span>
                            </Tooltip>
                          </span>
                          <span
                            onClick={() => openCommentModal(item.Id, "Decline")}
                            style={{ cursor: "pointer", color: "#dd2735" }}
                          >
                            <Tooltip title="Decline" placement="top">
                              <span className={classes.icon}>
                                <Decline />
                              </span>
                            </Tooltip>
                          </span>
                        </span>
                      )
                    )}
                    {item.Status === 1 && (
                      <span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => openViewMore(item)}
                        >
                          <Tooltip title="View" placement="top">
                            <span className={classes.icon}>
                              <ViewIcon />
                            </span>
                          </Tooltip>
                        </span>
                      </span>
                    )}
                    {item.Status === 2 && (
                      <span>
                        <span onClick={() => openViewMore(item)}>
                          <Tooltip title="View" placement="top">
                            <span className={classes.icon}>
                              <ViewIcon />
                            </span>
                          </Tooltip>
                        </span>
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter />
        </Table>
      </div>
    </div>
  );
}

class AllDataEntryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      classes,
      totalCount,
      pageSize,
      currentPage,
      filterAirlines,
      filterUsers,
      filterStatus,
      approveDataEntry,
      declineDataEntry,
      openEditModal,
      closeEditModal,
      isEditModalOpen,
      handleUpdate,
      newAirlineId,
      airlines,
      selectChange,
      pendingDataEntryId,
      isCommentModalOpen,
      openCommentModal,
      closeCommentModal,
      comment,
      processName,
      fetchDataEntry,
      dataEntryData,
      user,
      openViewMore,
    } = this.props;
    return (
      <div>
        <RecordPagination
          fetchMore={fetchDataEntry}
          totalCount={totalCount}
          pageSize={pageSize}
          currentPage={currentPage}
          target={
            <DataEntryTableStructure
              classes={classes}
              dataEntryData={dataEntryData}
              filterAirlines={filterAirlines}
              filterUsers={filterUsers}
              filterStatus={filterStatus}
              approveDataEntry={approveDataEntry}
              declineDataEntry={declineDataEntry}
              openEditModal={openEditModal}
              closeEditModal={closeEditModal}
              isEditModalOpen={isEditModalOpen}
              handleUpdate={handleUpdate}
              selectChange={selectChange}
              newAirlineId={newAirlineId}
              airlines={airlines}
              pendingDataEntryId={pendingDataEntryId}
              isCommentModalOpen={isCommentModalOpen}
              openCommentModal={openCommentModal}
              closeCommentModal={closeCommentModal}
              comment={comment}
              processName={processName}
              user={user}
              openViewMore={openViewMore}
            />
          }
        />
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(AllDataEntryTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/DataEntry/AllDataEntryTable.jsx